var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59956 4C5.75866 4.00002 5.91089 4.06328 6.02339 4.17578L8.02339 6.17578C8.25765 6.41008 8.25765 6.78913 8.02339 7.02344C7.78909 7.25774 7.41005 7.25771 7.17574 7.02344L6.19917 6.04688V10.5996C6.19917 10.931 5.93089 11.1992 5.59956 11.1992C5.26819 11.1992 4.99995 10.931 4.99995 10.5996V6.04688L4.02339 7.02344C3.78909 7.25774 3.41005 7.25771 3.17574 7.02344C2.94142 6.78912 2.94142 6.4101 3.17574 6.17578L5.17574 4.17578C5.28825 4.06329 5.44046 4 5.59956 4Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3994 11.9993C10.5585 11.9993 10.7107 11.936 10.8232 11.8235L12.8232 9.82349C13.0575 9.58918 13.0575 9.21014 12.8232 8.97583C12.5889 8.74152 12.2099 8.74154 11.9755 8.97583L10.999 9.95239V5.39966C10.999 5.0683 10.7307 4.80007 10.3994 4.80005C10.068 4.80005 9.79976 5.06829 9.79976 5.39966V9.95239L8.8232 8.97583C8.58889 8.74152 8.20986 8.74154 7.97554 8.97583C7.74123 9.21014 7.74123 9.58917 7.97554 9.82349L9.97554 11.8235C10.0881 11.936 10.2402 11.9993 10.3994 11.9993Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/Sort.19a79bbbc6c07c5769872279690bd5fe.svg";
export { ForwardRef as ReactComponent };